export enum HubspotFormTypeEnum {
    MEDIA_DATABASE = 0,
    MEDIA_MONITORING = 1,
    SOCIAL_LISTENING = 2,
    NEWSWIRE = 3,
    MEDIA_INTELLIGENCE_SERVICE = 4,
    INTELLIGENT_INSIGHTS = 5,
    ANNUAL_MEDIA_REPORT = 6,
    COVERAGE_INSIGHTS = 7,
    AEO_SCOUT = 8,
    AGENTIC_FEATURES = 9,
    // TODO: NEP-38233 - Need an enum for visibility intelligence
    // VISIBILITY_INTELLIGENCE = 10
}
